module.exports = __webpack_public_path__ + "img/mainte.b5b1b473.png";